import { render } from "./SubirPlaza.vue?vue&type=template&id=2d32b9a6"
import script from "./SubirPlaza.vue?vue&type=script&lang=js"
export * from "./SubirPlaza.vue?vue&type=script&lang=js"

import "./SubirPlaza.vue?vue&type=style&index=0&id=2d32b9a6&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__